<script setup>
import { ref } from 'vue'
import Scene from '@components/about/Scene.vue'
import LoadingOverlay from '@components/global/LoadingOverlay.vue'

const loaded = ref(false)
</script>

<template>
	<LoadingOverlay v-if="!loaded" />
	<Scene class="h-dvh" :onLoad="() => (loaded = true)" />
</template>
